export const GET_CATEGORY_FEATURES_START =
  'GET_CATEGORY_FEATURES_START';
export const GET_CATEGORY_FEATURES_SUCCESS =
  'GET_CATEGORY_FEATURES_SUCCESS';
export const GET_CATEGORY_FEATURES_ERROR =
  'GET_CATEGORY_FEATURES_ERROR';
